<template>
  <v-row justify="center">
    <v-dialog
      v-model="mainDialog"
      @input="dismiss($event)"
      scrollable
      max-width="345px"
    >
      <v-card>
        <v-card-title>Report room</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form
            ref="reportForm"
            autocomplete="off"
            @submit.prevent="submit()"
          >
            <v-select
              v-model="reasonSelector"
              :items="reasons"
              single-line
              label="Reason"
              class="mb-0 pb-0"
              :rules="reasonRules"
            ></v-select>
            <v-textarea
              v-model="descriptionSelector"
              name="input-7-1"
              label="Description"
              maxlength="1024"
              counter
              no-resize
              class="mt-0 pt-0"
              hint="Be concise!"
              :rules="descriptionRules"
            ></v-textarea>
            <v-btn block color="black" class="mt-2" @click="submit()" dark
              >Submit</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<style></style>

<script>
import { Reasons } from "@/tools/config.js";
export default {
  props: ["user"],
  data: () => ({
    mainDialog: false,
    resolve: null,
    reasons: Reasons,
    reasonSelector: "",
    descriptionSelector: "",
    reasonRules: [v => !!v || "Reason is required"],
    descriptionRules: [
      v => !!v || "Description is required",
      v => (v && v.length >= 32) || "Must be >= 32 characters",
      v => (v && v.length <= 1024) || "Must be <= 1024 characters"
    ]
  }),
  methods: {
    dismiss(state) {
      if (!state && this.resolve !== null) {
        this.reasonSelector = "";
        (this.descriptionSelector = ""), this.resolve(false);
      }
    },
    open() {
      this.mainDialog = true;
      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },
    submit() {
      if (this.$refs.reportForm.validate()) {
        this.mainDialog = false;
        let object = {
          reason: this.reasonSelector,
          description: this.descriptionSelector
        };
        this.resolve(object);
      }
    }
  }
};
</script>
